export default "__VITE_ASSET__C0mecSL7__"